import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import BusinessRevenueSettings from "./revenueSplitTabs/businesses";
import ShipperRevenueSettings from "./revenueSplitTabs/shippers";

const tabs = [
  { name: "Businesses", href: "businesses" },
  { name: "Shippers", href: "shippers" },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function RevenueSettings() {
  const DEFAULT_ACTIVE_TAB = "businesses";
  const navigate = useNavigate();
  const { split_tab } = useParams();
  const [activeTab, setActiveTab] = useState(split_tab || DEFAULT_ACTIVE_TAB);

  useEffect(() => {
    if (split_tab) {
      setActiveTab(split_tab);
    }
  }, [split_tab]);

  const toggle = (tab) => {
    if (activeTab !== tab.href) {
      setActiveTab(tab.href);
      navigate(`/admin/revenue/revenue-settings/${tab.href}`);
    }
  };

  return (
    <div>
      {/* <div className="mb-6">
        <h1 className="text-2xl font-semibold text-gray-900 dark:text-white">
          Revenue Split
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-1">
          Manage revenue split for businesses and shippers
        </p>
      </div> */}

      <div className="border-b border-gray-200 dark:border-gray-700 mb-0">
        <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              onClick={() => toggle(tab)}
              className={classNames(
                tab.href === activeTab
                  ? "border-primary text-primary font-bold"
                  : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300",
                "whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
              )}
              aria-current={tab.href === activeTab ? "page" : undefined}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      <div>
        {activeTab === "businesses" && <BusinessRevenueSettings />}
        {activeTab === "shippers" && <ShipperRevenueSettings />}
      </div>
    </div>
  );
}
